import React from 'react';

import NavArrow from '../../shared/components/nav-arrow';
import { Carousel, setCarouselHeight } from '../../shared/components/carousel';
import { withError } from '../../shared/components/error-boundary';
import XSellProductCard from './tabs/xsell-product-card';
import DropDown from '../../shared/components/dropdown';
import { Helpers } from '../../core/src/helpers';

import '../css/pdp-cat-acc-carousel.less';

const { memoize } = Helpers;

const ACCY_CAT_MODIFIER = {
    'xm5DJ': 'Monitors',
    'jRHnr': null,
    'ODWIB': null,
    'eXn4F': null,
    'hRrU3': null,
    'KiBhB': null,
    "J03oV": null,
    "OwSKW": null,
    "70m-W": null,
    "rwWX0": null
}

class CategorizedAccCarousel extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            catIndex: 0
        }
        this.selectCategory = this.selectCategory.bind(this);
    }

    categories = memoize((sku) =>{
        const { product: { xsell } } = this.props;
        
        if(xsell.length > 0){
            let categories = this.generateCategories(xsell);
            return categories;
        }
        return {};
    },(sku) => {
        const { product: { xsell } } = this.props;
        return `${sku}-${xsell.length}`;
    })

    filteredProducts = memoize((index, categories) =>{
        const products = this.props.product.xsell || [];
        if(categories.length === 0){
            return products;
        }
        return products.filter((product, i)=> product.categories.some((cat)=> cat._id === (categories[this.state.catIndex] || {})._id));
    },(index, categories) => {
        const products = this.props.product.xsell;
        return `${index}-${products.length}`
    })

    componentDidUpdate(prevProps) {
        if(this.props.isActive && prevProps.isActive !== this.props.isActive && this.carousel) {
            setCarouselHeight(this.carousel);
        }
    }

    componentDidMount(){
        const categories = this.categories(this.props.product.sku);
    }

    generateCategories(products){
        let catMap = {};
        return products.reduce((arr, xsellItem) => {
            xsellItem.categories.forEach((category) => {
                if(category.displayName != "All" && category.location && !(category._id in catMap) && category.tags instanceof Array && category.tags.indexOf('pdp') >= 0){
                    category.location = category.location.slice(0, category.location.indexOf('<'));
                    arr.push(category);
                    catMap[category._id]=1;
                }
            });
            return arr;
        },[]);
    }

    getIcon(name){
        const className =name.replace(/_/gi, "-");
        return(
            <div className={'hp-icon default ' + className }></div>
        );
    }

    selectCategory(index){
        this.setState({catIndex: index});
    }

    populateCategories(categories, selectedCategory){
        const settings = {
            slidesToShow: 6,
            slidesToScroll: 1,
            ...this.controls(),
        };
        return(
            <div>
                <Carousel className='accessories-cat' {...settings} ref={carousel => this.carousel = carousel}>
                    {categories.reduce((allCatgories, category, i) => {
                        let nextCat = ACCY_CAT_MODIFIER[category && category._id];

                        if(nextCat === null){
                            return allCatgories;
                        }

                        allCatgories.push(
                            <div key={category+'-'+i} className={`cat-item${category._id === selectedCategory._id ? ' selected' : ''}`} onClick={()=>this.selectCategory(i)}>
                                {this.getIcon(category.location)}
                                <p className='cat-title'>{ nextCat || category.displayName}</p>
                            </div>
                        );

                        return allCatgories;
                    },  [])}
                </Carousel>
                <DropDown className='accessories-dropdown' options={categories} displayKey={'displayName'} selectOption={this.selectCategory} initialValue={this.state.catIndex}/>
            </div>
        )
    }

    controls() {
        return {
            renderCenterLeftControls : NavArrow.PrevArrow,
            renderCenterRightControls: NavArrow.NextArrow,
            renderBottomCenterControls: () => <div></div>
        }
    }

    render(){
        const products = this.props.product.xsell;
        const categories = this.categories(this.props.product.sku);
        const selectedCategory = categories[this.state.catIndex];
        const tabHeaderCategory = products.length > 0 ? 'Browse Accessories' : null;
        const filteredProducts = this.filteredProducts(this.state.catIndex, categories);
        
        return(
            <div className={`cat-acc-carousel${this.props.className ? ' '+this.props.className : ''}`}>
                <div className={`pdp-tab-header${categories.length === 0 ? ' mobile-only' : ''}`}>{tabHeaderCategory}</div>
                {categories.length > 0 && this.populateCategories(categories, selectedCategory)}
                <ul className={`filtered-products${categories.length === 0 ? ' mobile-only' : ''}`}>
                    {filteredProducts.map((product, i)=>
                        <li key={product.sku+i} className='filtered-product'>
                            <XSellProductCard
                                product={product}
                                ctaMetrics={this.props.ctaMetrics}
                                productClickMetrics={this.props.productClickMetrics}
                                baseProductSku={this.props.baseProductSku}
                                xsellType={this.props.xsellType}
                            />
                        </li>
                    )}
                </ul>
            </div>
        )
    }
}

export default withError(CategorizedAccCarousel);
